import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AeroCloudContext } from 'app/models/aero-cloud.model';
import { API_ROUTES } from 'app/util/route.constants';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AeroCloudService {
  sessionKey = '';
  callBackUrl = '';
  context: AeroCloudContext;
  BASE_URL = environment.cva_url + API_ROUTES.AEROCLOUD_ENDPOINT;
  patientContextKey = '';
  sessionId = '';

  constructor(
    private _http: HttpClient,
  ) { }

  getContext() {
    const requestBody = JSON.parse(JSON.stringify({
      sessionKey: this.sessionKey,
      callbackUrl: encodeURIComponent(this.callBackUrl),
    }));
    return this._http.post<{ response: AeroCloudContext }>(`${this.BASE_URL}/context`, requestBody).pipe(
      map(response => {
        return response.response;
      }));
  }

  postNotes(notes: { [key: string]: string }) {
    const requestBpdy = JSON.parse(JSON.stringify({
      notes: JSON.parse(JSON.stringify(notes)),
      patientId: this.context.patientReferenceId,
      providerId: this.context.providerReferenceId,
      sessionKey: this.sessionKey,
      callbackUrl: encodeURIComponent(this.callBackUrl),
    }));
    return this._http.post<{ response: { success: boolean } }>(`${this.BASE_URL}/post-notes`, requestBpdy).pipe(
      map(response => {
        return response;
      }));
  }

  postLetter(letter: string) {
    const requestBody = JSON.parse(JSON.stringify({
      letter,
      patientId: this.context.patientReferenceId,
      sessionKey: this.sessionKey,
      callbackUrl: encodeURIComponent(this.callBackUrl),
      patientName: this.context.patientName
    }));
    return this._http.post<{ response: { success: boolean } }>(`${this.BASE_URL}/post-letter`, requestBody).pipe(
      map(response => {
        return response;
      }));
  }

}
